import { ConnectionBackend, RequestOptions } from '@angular/http';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { InterceptorService } from './interceptor-service';

export function provideInterceptorService(backend: ConnectionBackend, defaultOptions: RequestOptions) {
  return new InterceptorService(backend, defaultOptions);
}


export class InterceptorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [
    {
      provide: InterceptorService,
      useFactory: provideInterceptorService,
      deps: [ConnectionBackend, RequestOptions]
    }
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
